<template>
    <div id="app">
        <Header/>
        <Tariffs/>
        <Footer/>
        <Modals/>
    </div>
</template>

<script>
    import 'bootstrap/dist/css/bootstrap.css'
    import 'bootstrap-vue/dist/bootstrap-vue.css'

    export default {
        name: 'App',
        components: {
            Header: () => import(/* webpackChunkName: "header" */'./components/Header'),
            Tariffs: () => import(/* webpackChunkName: "tariffs" */'./components/TariffsTab'),
            Footer: () => import(/* webpackChunkName: "footer" */'./components/Footer'),
            Modals: () => import(/* webpackChunkName: "modals" */'./components/Modals'),
        },
    }
</script>

<style lang="scss">
    #app {
        font-family: 'Roboto', sans-serif;
        background: #E5E5E5;

        .container {
            max-width: 1300px;
        }
    }

    .btn {
        &__pay {
            display: block;
            font-weight: 500;
            font-size: 16px;
            line-height: 19px;
            text-align: center;
            text-transform: uppercase;

            color: #FFFFFF;

            background: #BC9B69;
            border-radius: 4px;
            padding: 15px 25px;
            border: none;
            outline: none;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);

            transition: all .3s;

            &:hover {
                background: #9A7B4F;
            }

            &:active {
                background: #9A7B4F;
            }

            &:focus {
                box-shadow: none;
                background: #9A7B4F;
            }
        }
    }

    @media screen and (max-width: 834px) {
        #app {
            .container {
                max-width: 1300px;
                padding: 0;
            }
        }

        .btn {
            &__pay {
                font-size: 12px;
                line-height: 14px;

                padding: 10.5px 25px;
            }
        }
    }
</style>
